function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Context } from './context';
export var DependencyProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(DependencyProvider, _Component);

  function DependencyProvider(props) {
    var _this;

    _classCallCheck(this, DependencyProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DependencyProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDependencies", function (componentType) {
      var _this$props = _this.props,
          target = _this$props.target,
          use = _this$props.use; // First we collect dependencies from parent providers (if any)
      // If none, we get the default context value

      var dependencies = _this.context.getDependencies(componentType); // Only assign own provider deps if no target
      // or target is the same component that is calling provide()


      if (!target || componentType === target) {
        Object.assign(dependencies, use);
      }

      return dependencies;
    });

    _this.state = {
      getDependencies: _this.getDependencies
    };
    return _this;
  }

  _createClass(DependencyProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(Context.Provider, {
        value: this.state
      }, children);
    }
  }]);

  return DependencyProvider;
}(Component);

_defineProperty(DependencyProvider, "contextType", Context);

_defineProperty(DependencyProvider, "propTypes", {
  target: PropTypes.func,
  use: PropTypes.objectOf(PropTypes.any).isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
});